var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"error-page fill-height",attrs:{"tag":"section"}},[_c('v-row',{staticClass:"text-center",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('div',{staticClass:"display-3 mb-5 mt-10"},[_c('a',{attrs:{"href":"/#/1/pages/login"}},[_vm._v("Zaloguj się")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }